import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useGetPortalInstanceListingQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/PortalInstanceListingRpc.hooks';
import { getPortalInstanceId, getPortalAccountId } from '../utils/metadata';
import { useLoginVerify } from '../hooks/useLoginVerify';
import { usePortalsPlatformObjectId } from '../context/PortalsPlatformObjectIdContext';
import { InvitePanel } from './InvitePanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function InviteButton({
  objectId: objectIdProp,
  onInviteSuccess
}) {
  var _portalInstanceListin, _portalInstanceListin2;
  const [isOpen, setIsOpen] = useState(false);
  const portalInstanceId = getPortalInstanceId();
  const accountId = getPortalAccountId();
  const contextObjectId = usePortalsPlatformObjectId();
  const objectId = objectIdProp !== null && objectIdProp !== void 0 ? objectIdProp : contextObjectId;
  const {
    data: loginVerifyData
  } = useLoginVerify({
    objectId
  });
  const {
    data: portalInstanceListingData
  } = useGetPortalInstanceListingQuery({
    variables: {
      portalInstanceId,
      accountId
    }
  });
  const invitationsEnabled = portalInstanceListingData === null || portalInstanceListingData === void 0 || (_portalInstanceListin = portalInstanceListingData.portalInstanceListing) === null || _portalInstanceListin === void 0 ? void 0 : _portalInstanceListin.invitationsEnabled;
  const spaceName = portalInstanceListingData === null || portalInstanceListingData === void 0 || (_portalInstanceListin2 = portalInstanceListingData.portalInstanceListing) === null || _portalInstanceListin2 === void 0 ? void 0 : _portalInstanceListin2.displayName;
  if (!loginVerifyData || portalInstanceId === undefined || accountId === undefined) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      use: "tertiary-transparent",
      size: "sm",
      onClick: () => setIsOpen(true),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.invitePanelButton.label"
      })
    }), isOpen && /*#__PURE__*/_jsx(InvitePanel, {
      onClose: () => setIsOpen(false),
      onSuccess: onInviteSuccess,
      portalInstanceId: portalInstanceId,
      accountId: accountId,
      portalUserRole: loginVerifyData.portalUserRole,
      objectId: objectId,
      invitationsEnabled: invitationsEnabled,
      spaceName: spaceName
    })]
  });
}